export class vehiclesPaged {
    constructor(
        public totalItems: number,
        public items: Vehicle[]
    ) { }
}

export class Vehicle {
    constructor() { }

    public id: number;
    public vehicleGuid: string;
    public assignorId: number;
    public assignorCardId: number;
    public nickName: string;
    public registrationPlate: string;
    public renavam: string;
    public model: string;
    public manufacturer: string;
    public modelYear: number;
    public manufactureYear: number;
    public specieId: number;
    public fuelId: number;
    public fuelConsumption: number;
    public creationDate: Date;
    public updateDate: Date;
    public deactivationDate: Date;
    public isActive: boolean;
    public creationManagerId: number;
    public updateManagerId: number;
    public cardId: string;
    public cardActive: boolean;
    public definitiveBlock: boolean;
    public temporaryBlock: boolean;
    public lastDigits: string;
    public transactionsPerDay: number;
    public transactionMaxValue: number;
    public transactionsMaxValuePerDay: number;
}

export class vehicleCreate {
    public model: string;
    public fuelId: number;
    public renavam: number;
    public nickName: string;
    public specieId: number;
    public modelYear: number;
    public manufacturer: string;
    public manufactureYear: number;
    public fuelConsumption: number;
    public registrationPlate: string;
    public transactionsPerDay: number;
    public transactionMaxValue: number;
    public transactionsMaxValuePerDay: number;
    constructor() { }
}

export class Species {
    public id: number;
    public isActive: boolean;
    public description: string;
    constructor() { }
}

export class Fuels {
    public id: number;
    public description: string;
    constructor() { }
}

export class FilterVehicle {
    public fuel: number;
    public model: string;
    public nickName: string;
    public manufacturer: string;
    public registrationPlate: string;
    constructor() { }
}

export class ExtractVehicles {
    public id: number;
    public nickName: string;
    public registrationPlate: string;
    public model: string;
    public transactionDate: Date;
    public value: number;
    public receiver: string;
    public lastDigits: string;
    constructor() { }
}

